import { doRequest } from '../../api/index';

const state = {
  events: null,
};

const getters = {
  userEventRegistrations(s) {
    return s.events;
  }
};

const actions = {
  registerToEvent({ commit }, args) {
    return doRequest('user.registerToEvent', args).then(() => {
      commit('setUserEvents', null);
    })
  },
  userEvents({commit}, args) {
    return doRequest('user.userEvents', args).then((data) => {
      commit('setUserEvents', data.data);
    });
  },
  editUserEvent({commit}, args) {
    return doRequest('user.editUserEvent', args);
  },
  unsubscribeEvent({commit}, args) {
    return doRequest('events.unsubscribeEvent', args);
  },
  subscribeEvent({commit}, args) {
    return doRequest('events.subscribeEvent', args);
  }
};

const mutations = {
  setUserEvents(s, events) {
    s.events = events;
  },
};


export default {
  state,
  getters,
  actions,
  mutations,
};
